export class Parameter {
  id?: number;
  name?: string;
  keyCode?: string;
  description?: string;
  valueData?: any;
  editable?: boolean;

  constructor(source: Partial<Parameter>) {
    Object.assign(this, source);
  }
}
